import { useNavigate } from "react-router-dom";
import { Check, ArrowRight, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import SiteLayout from "@/components/SiteLayout";

const included = [
  "Valutazione generale con punteggio e livello di rischio",
  "Analisi dei prezzi: voci coerenti, in fascia alta e non valutabili",
  "Completezza: lavorazioni presenti e possibili mancanti",
  "Possibili extracosti e opere non incluse",
  "Ambiguità: voci “a corpo”, quantità e materiali poco chiari",
  "Domande concrete da fare all’impresa",
  "Messaggio pronto da copiare e inviare",
  "Link permanente al report, anche via email",
];

export default function Prezzi() {
  const navigate = useNavigate();
  return (
    <SiteLayout
      seo={{ title: "Prezzi", description: "OKKIO costa €9,99 per il report completo di un preventivo. Anteprima gratuita, nessun abbonamento. Indipendente per davvero.", path: "/prezzi" }}
      breadcrumbs={[{ label: "Home", to: "/" }, { label: "Prezzi", to: "/prezzi" }]}
      narrow>
      <h1 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-slate-900 leading-[1.1]">Un prezzo semplice e trasparente</h1>
      <p className="mt-5 text-lg text-slate-600 leading-relaxed">
        Nessun abbonamento, nessun costo nascosto. Paghi solo quando vuoi il report completo.
      </p>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="rounded-3xl border border-slate-200 bg-white p-8">
          <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">Anteprima</p>
          <p className="mt-3 font-heading text-4xl font-semibold text-slate-900">Gratis</p>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Importo totale, numero di voci, conteggio delle criticità, livello di rischio e una criticità completa come esempio.
          </p>
          <Button variant="outline" data-testid="pricing-free-cta" onClick={() => navigate("/controlla-preventivo")}
            className="mt-6 w-full rounded-full font-semibold border-slate-300">Prova gratis</Button>
        </div>

        <div className="rounded-3xl border-2 border-slate-900 bg-white p-8 relative">
          <span className="absolute top-5 right-5 rounded-full bg-slate-900 text-white text-xs font-semibold px-3 py-1">Report completo</span>
          <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">Report</p>
          <p className="mt-3 font-heading text-4xl font-semibold text-slate-900">€9,99 <span className="text-base font-normal text-slate-400">una tantum</span></p>
          <ul className="mt-5 space-y-2.5">
            {included.map((it) => (
              <li key={it} className="flex items-start gap-2.5 text-sm text-slate-700">
                <Check className="w-4 h-4 text-emerald-500 mt-0.5 flex-shrink-0" strokeWidth={2.25} /> {it}
              </li>
            ))}
          </ul>
          <Button data-testid="pricing-paid-cta" onClick={() => navigate("/controlla-preventivo")}
            className="mt-7 w-full rounded-full py-3.5 font-semibold bg-[#3157F6] hover:bg-[#2444D8] active:scale-95 transition-transform">
            Controlla il tuo preventivo <ArrowRight className="w-4 h-4 ml-1" />
          </Button>
        </div>
      </div>

      <div className="mt-8 rounded-2xl bg-slate-50 border border-slate-200 p-6 flex items-start gap-3">
        <Lock className="w-5 h-5 text-slate-500 flex-shrink-0 mt-0.5" strokeWidth={1.5} />
        <p className="text-sm text-slate-600 leading-relaxed">
          Il ricavo di OKKIO deriva esclusivamente dal report che acquisti tu. Non riceviamo compensi dalle imprese
          analizzate: il nostro cliente sei tu, non l’impresa.
        </p>
      </div>
    </SiteLayout>
  );
}
